import service from '@/utils/server';

const modName = '/configCenter/importTemplateConfig/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//新增方法
export const addData = data => {
  return service({
    url: modName + 'add',
    method: 'post',
    data
  });
};

//初始化修改
export const initEdit = data => {
  return service({
    url: modName + 'initEdit/' + data.id,
    method: 'post',
    data
  });
};

//修改方法
export const editData = data => {
  return service({
    url: modName + 'edit',
    method: 'post',
    data
  });
};


//作废方法
export const cancelData = data => {
  return service({
    url: modName + 'deprecatedData',
    method: 'post',
    data
  });
};

//根据模版类型查询系统字段
export const templateSystemColumn = data => {
  return service({
    url: modName + 'templateSystemColumn/' + data.typeCode,
    method: 'post',
    data
  });
};

/**
 * 导入模版配置
 * @param data
 * @returns {*}
 */
export const importCustomerTemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'importCustomerTemplate',
    method: 'post',
    data
  });
};

/**
 * 常量明细
 * @param data
 * @returns {*}
 */
export const selectSmBaseDtByDataType = data => {
  return service({
    url: modName + 'selectSmBaseDtByDataType',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/configurationCenter/importTemplateSettings/api/index.js